<template>
    <v-card color="#F4FEFB">
        <v-container class="pr-14">
            <v-row>
                <v-img
                    :src="selectSealData"
                    max-height="300"
                    max-width="300"
                    width="300"
                    height="300"
                    :contain="true"
                >
                </v-img>
                <seal-upload-component
                    @selectSeal="selectSeal"
                ></seal-upload-component>
                <search-seal-component
                    @selectRegisteredSeal="selectRegisteredSeal"
                ></search-seal-component>
            </v-row>
            <v-row justify="center">
                <v-col
                    cols="2"
                >
                    <v-btn
                        block
                        color="white"
                        v-on:click="cancelSeal"
                    >
                        キャンセル
                    </v-btn>
                </v-col>
                <v-col
                    cols="2"
                >
                    <v-btn
                        block
                        color="red"
                        class="white--text"
                        v-on:click="registerSeal"
                    >
                        押印
                    </v-btn>
                </v-col>
            </v-row>
        </v-container>
    </v-card>
</template>

<script>
export default {
    props: [],
    data: function () {
        return {
            selectDestinations: [],
            selectSealData: '',
        }
    },
    created: function () {
    },
    methods: {
        cancelSeal: function () {
            this.$emit('cancelSeal')
        },
        selectSeal: function (sealData) {
            this.selectSealData = sealData
        },
        selectRegisteredSeal: function (sealData) {
            this.selectSealData = sealData
        },
        registerSeal: function () {
            this.$emit('registerSeal', this.selectSealData)
        }
    }
}
</script>

<style scoped>

</style>